import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { mediaApi } from '../../api/mediaApi';
import { Button } from '../ui/Button';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Champ d'image réutilisable partout où le back-office attache une image de la
 * médiathèque à un contenu (service, article, réalisation, réglage...).
 *
 * Contrôlé via `value` (le chemin renvoyé par la médiathèque, ex: "/uploads/xxx.jpg")
 * et `onChange(media | null)` — appelé avec l'objet média choisi, ou null au retrait.
 */
export function MediaPicker({ label, value, onChange }) {
  const { data: medias } = useFetch(() => mediaApi.list('image'), []);
  const [ouvert, setOuvert] = useState(false);

  return (
    <div className="admin-form__field">
      {label && <label>{label}</label>}
      <div className="admin-image-picker">
        {value ? (
          <img src={`${API_URL}${value}`} alt="" className="admin-image-picker__preview" />
        ) : (
          <div className="admin-image-picker__preview admin-image-picker__preview--empty">Aucune image</div>
        )}
        <div className="admin-image-picker__actions">
          <Button type="button" variant="secondary" onClick={() => setOuvert(true)}>
            Choisir dans la médiathèque
          </Button>
          {value && (
            <Button type="button" variant="ghost" onClick={() => onChange(null)}>
              Retirer
            </Button>
          )}
        </div>
      </div>

      {ouvert && (
        <div className="admin-image-gallery__overlay" onClick={() => setOuvert(false)}>
          <div className="admin-image-gallery" onClick={(e) => e.stopPropagation()}>
            <h3>Choisir une image</h3>
            <div className="admin-image-gallery__grid">
              {medias?.map((m) => (
                <button
                  type="button"
                  key={m.id}
                  className="admin-image-gallery__item"
                  onClick={() => {
                    onChange(m);
                    setOuvert(false);
                  }}
                >
                  <img src={`${API_URL}${m.chemin}`} alt={m.alt_text || m.nom_fichier} />
                </button>
              ))}
              {!medias?.length && (
                <p>
                  Aucune image dans la médiathèque. Ajoutez-en depuis <strong>Médiathèque</strong> dans le menu.
                </p>
              )}
            </div>
            <Button type="button" variant="secondary" onClick={() => setOuvert(false)}>
              Fermer
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
